import React, { PropTypes, Component } from 'react';
import classNames from 'classnames/bind';
const cx = classNames.bind();

const GridHeaderComponent = ({ displayName, defaultSortIcon = true }) => {
    const columnHeaderStyle = cx({
        'grid-sort-default': defaultSortIcon
    });

    return (
        <div className={columnHeaderStyle}>
            <span>
                {displayName}
            </span>
        </div>
    );
};

GridHeaderComponent.propTypes = {
    defaultSortIcon: PropTypes.bool,
    displayName: PropTypes.string
};

export default GridHeaderComponent;



// WEBPACK FOOTER //
// ./src/components/utils/TableUtils/GridHeaderComponent.js